(function(){
  function init(){
    var productType=(document.querySelector('.product-type')||{}).innerText||'';
    var simpleProduct=/fragrance|perfume|beauty|cosmetic|accessor/i.test(productType);
    document.body.classList.toggle('ff-simple-product',simpleProduct);
    if(simpleProduct){
      document.querySelectorAll('.ff-options-heading').forEach(function(el){el.remove()});
    }
    document.querySelectorAll('[data-ff-announcement]').forEach(function(slider){
      if(slider.dataset.ffReady)return;
      slider.dataset.ffReady='1';
      var slides=Array.from(slider.querySelectorAll('.ff-announcement-slide'));
      if(slides.length<2)return;
      var index=0,timer;
      function show(next){slides[index].classList.remove('is-active');index=(next+slides.length)%slides.length;slides[index].classList.add('is-active')}
      function start(){clearInterval(timer);timer=setInterval(function(){show(index+1)},parseInt(slider.dataset.interval||'4500',10))}
      var prev=slider.querySelector('.ff-announcement-prev'),next=slider.querySelector('.ff-announcement-next');
      if(prev)prev.addEventListener('click',function(){show(index-1);start()});
      if(next)next.addEventListener('click',function(){show(index+1);start()});
      slider.addEventListener('mouseenter',function(){clearInterval(timer)});
      slider.addEventListener('mouseleave',start);
      start();
    });
    var mainGallery=document.querySelector('.product-photo-container.slider-for');
    var imageWrapper=document.querySelector('.product-img-box .wrapper-images');
    if(mainGallery&&imageWrapper&&mainGallery.querySelectorAll('.slick-slide').length>1&&!imageWrapper.querySelector('.ff-gallery-arrow')){
      var previous=document.createElement('button'),following=document.createElement('button');
      previous.type='button';previous.className='ff-gallery-arrow ff-gallery-prev';previous.setAttribute('aria-label','Previous image');previous.innerHTML='&#8249;';
      following.type='button';following.className='ff-gallery-arrow ff-gallery-next';following.setAttribute('aria-label','Next image');following.innerHTML='&#8250;';
      imageWrapper.appendChild(previous);imageWrapper.appendChild(following);
      previous.addEventListener('click',function(){if(window.jQuery&&jQuery.fn.slick)jQuery(mainGallery).slick('slickPrev')});
      following.addEventListener('click',function(){if(window.jQuery&&jQuery.fn.slick)jQuery(mainGallery).slick('slickNext')});
    }
    var productTabs=document.querySelector('.tabs__product-page');
    if(productTabs&&!productTabs.dataset.ffCollapsed){
      productTabs.dataset.ffCollapsed='1';
      if(window.innerWidth<992){
        productTabs.querySelectorAll('.tab-links.active,.tab-content.active').forEach(function(el){el.classList.remove('active')});
      }else{
        var description=productTabs.querySelector('#collapse-tab1');
        var descriptionLinks=Array.from(productTabs.querySelectorAll('.tab-links')).filter(function(link){
          return /description/i.test(link.textContent);
        });
        if(description)description.classList.add('active');
        descriptionLinks.forEach(function(link){link.classList.add('active')});
      }
    }
    document.querySelectorAll('.collection-des').forEach(function(el){
      var btn=el.parentElement&&el.parentElement.querySelector('.ff-collection-read-more');
      if(!btn||el.dataset.ffReady)return;
      el.dataset.ffReady='1';
      if(el.scrollHeight>150){
        el.classList.add('ff-collapsed');btn.classList.add('is-visible');
        btn.addEventListener('click',function(){
          var closed=el.classList.toggle('ff-collapsed');
          btn.textContent=closed?'Read more':'Show less';
          btn.setAttribute('aria-expanded',String(!closed));
        });
      }
    });
    document.querySelectorAll('.search-form input[name="q"]').forEach(function(input){
      var form=input.closest('.search-form');
      function sync(){form&&form.classList.toggle('ff-query-active',input.value.trim().length>0)}
      input.addEventListener('input',sync);sync();
      if(!input.placeholder)input.placeholder='Search by designer, product or article code';
    });
    document.querySelectorAll('.product-shop .selector-wrapper').forEach(function(row){
      var label=row.querySelector('label');
      if(label&&/stitch/i.test(label.textContent))row.classList.add('ff-stitching-option');
    });
    document.querySelectorAll('.footer-bottom').forEach(function(el){
      el.childNodes.forEach(function walk(node){
        if(node.nodeType===3)node.nodeValue=node.nodeValue.replace(/©\s*2023/g,'© '+new Date().getFullYear());
        else if(node.childNodes)node.childNodes.forEach(walk);
      });
    });
  }

  // Marketplace-style product layout enhancements.
  var productRoot=document.querySelector('[data-section-type="product"]');
  if(productRoot){
    document.body.classList.add('ff-marketplace-product');
    var form=document.querySelector('#add-to-cart-form');
    var options=document.querySelector('#infiniteoptions-container');
    if(form&&options&&options.children.length&&!form.querySelector('.ff-options-heading')){
      var heading=document.createElement('div');
      heading.className='ff-options-heading';
      heading.innerHTML='<strong>Choose your options</strong><span>Select unstitched or stitching preferences before adding to bag.</span>';
      options.parentNode.insertBefore(heading,options);
    }
    document.querySelectorAll('.ff-options-heading').forEach(function(h){
      h.style.cssText='margin:0 0 12px;padding:11px 12px;background:#f7f7f7;border-radius:6px';
      var span=h.querySelector('span');if(span)span.style.cssText='display:block;margin-top:2px;font-size:12px;color:#666';
    });
  }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();

(function(){
  function setupMobileGallery(){
    var gallery=document.querySelector('.product-photo-container.slider-for');
    var wrapper=document.querySelector('.product-img-box .wrapper-images');
    if(!gallery||!wrapper||!window.matchMedia('(max-width: 991px)').matches)return;
    if(gallery.dataset.ffNativeGalleryReady==='1')return;
    if(!window.jQuery||!window.jQuery.fn.slick||!gallery.classList.contains('slick-initialized')){
      var retries=parseInt(gallery.dataset.ffGalleryRetries||'0',10);
      if(retries<40){gallery.dataset.ffGalleryRetries=String(retries+1);window.setTimeout(setupMobileGallery,250)}
      return;
    }
    window.jQuery(gallery).slick('unslick');
    gallery.classList.add('ff-native-gallery');
    gallery.dataset.ffNativeGalleryReady='1';
    var slides=Array.from(gallery.children).filter(function(slide){return slide.classList.contains('thumb')||slide.classList.contains('thum')});
    gallery.scrollLeft=0;
    window.requestAnimationFrame(function(){gallery.scrollTo({left:0,behavior:'auto'})});
    var total=slides.length;
    if(total<2)return;
    var count=wrapper.querySelector('.ff-gallery-count');
    if(!count){count=document.createElement('span');count.className='ff-gallery-count';count.setAttribute('aria-live','polite');count.innerHTML='<span>1</span>&nbsp;/&nbsp;<span>'+total+'</span>';wrapper.appendChild(count)}
    function updateCount(index){var current=wrapper.querySelector('.ff-gallery-count span:first-child');if(current)current.textContent=String((index||0)+1)}
    function closestSlide(){var target=gallery.scrollLeft+18,closest=0,distance=Infinity;slides.forEach(function(slide,index){var nextDistance=Math.abs(slide.offsetLeft-target);if(nextDistance<distance){distance=nextDistance;closest=index}});return closest}
    var galleryTicking=false;
    gallery.addEventListener('scroll',function(){if(galleryTicking)return;galleryTicking=true;window.requestAnimationFrame(function(){galleryTicking=false;updateCount(closestSlide())})},{passive:true});
    slides.forEach(function(slide,index){slide.setAttribute('aria-label','Product image '+(index+1)+' of '+total)});
    updateCount(0);
  }

  function setupStitchingPanel(){
    var options=document.querySelector('#infiniteoptions-container');
    var form=document.querySelector('#add-to-cart-form');
    if(!options||!form||options.closest('.ff-stitching-panel'))return;
    var productType=document.querySelector('.product-infor .product-type');
    var isUnstitched=/unstitched/i.test(productType?productType.textContent:document.body.className);
    if(!options.children.length&&!isUnstitched){
      if(options.dataset.ffStitchWatch==='1')return;
      options.dataset.ffStitchWatch='1';
      var waitingObserver=new MutationObserver(function(){if(options.children.length){waitingObserver.disconnect();delete options.dataset.ffStitchWatch;setupStitchingPanel()}});
      waitingObserver.observe(options,{childList:true});
      window.setTimeout(function(){waitingObserver.disconnect()},12000);
      return;
    }
    var panel=document.createElement('details'),summary=document.createElement('summary'),body=document.createElement('div'),toolbar=document.createElement('div'),loading=document.createElement('p');
    var heading=form.querySelector('.ff-options-heading');
    panel.className='ff-stitching-panel ff-has-toolbar';
    summary.className='ff-stitching-panel__summary';
    summary.innerHTML='<span class="ff-stitching-panel__lead"><span class="ff-stitching-panel__icon" aria-hidden="true"><svg viewBox="0 0 24 24" focusable="false"><path d="M9 3h5v4H9V3Zm2.5 0V1.8M14 2h3M7 7h8a4 4 0 0 1 4 4v4h-5.5a3.5 3.5 0 0 0-3.5 3.5H5V9a2 2 0 0 1 2-2Zm8 3h2v5h-2v-5Zm0 5v2M3.5 18.5h17V22h-17v-3.5Z"/></svg></span><span class="ff-stitching-panel__copy"><strong>Stitching Services</strong><small>– Get Your Clothes Stitched</small></span></span><span class="ff-stitching-panel__chevron" aria-hidden="true"></span>';
    body.className='ff-stitching-panel__body';toolbar.className='ff-stitching-toolbar';toolbar.innerHTML='<strong>Get it stitched online</strong>';loading.className='ff-stitching-loading';loading.textContent='Loading stitching options…';
    options.parentNode.insertBefore(panel,options);panel.appendChild(summary);panel.appendChild(body);body.appendChild(toolbar);body.appendChild(loading);body.appendChild(options);if(heading)heading.remove();
    function syncPanel(){var sizeGuide=form.querySelector('.size-chart-open-popup');if(sizeGuide&&!toolbar.contains(sizeGuide)){sizeGuide.classList.add('ff-stitching-size-guide');toolbar.appendChild(sizeGuide)}panel.classList.toggle('ff-options-ready',options.children.length>0)}
    syncPanel();
    var observer=new MutationObserver(syncPanel);observer.observe(form,{childList:true,subtree:true});window.setTimeout(function(){observer.disconnect()},15000);
  }

  function setupShareDialog(){
    var dialog=document.querySelector('.ff-share-dialog');
    var openButton=document.querySelector('[data-ff-share-open]');
    if(!dialog||!openButton||dialog.dataset.ffReady==='1')return;
    dialog.dataset.ffReady='1';
    var closeButton=dialog.querySelector('[data-ff-share-close]');
    var copyButton=dialog.querySelector('[data-ff-copy-link]');
    var nativeButton=dialog.querySelector('[data-ff-native-share]');
    openButton.addEventListener('click',function(){
      if(typeof dialog.showModal==='function')dialog.showModal();
      else dialog.setAttribute('open','');
    });
    if(closeButton)closeButton.addEventListener('click',function(){dialog.close()});
    dialog.addEventListener('click',function(event){if(event.target===dialog)dialog.close()});
    if(nativeButton)nativeButton.addEventListener('click',function(){
      var url=nativeButton.getAttribute('data-product-url');
      if(navigator.share){
        navigator.share({title:document.title,url:url}).catch(function(){});
        return;
      }
      navigator.clipboard.writeText(url).then(function(){
        nativeButton.textContent='Link copied — open Instagram';
        window.setTimeout(function(){nativeButton.innerHTML='<span class="ff-share-dialog__network ff-share-dialog__network--instagram" aria-hidden="true">◎</span>Instagram / More'},1800);
      }).catch(function(){nativeButton.textContent='Copy Link'});
    });
    if(copyButton)copyButton.addEventListener('click',function(){
      var url=copyButton.getAttribute('data-product-url');
      if(!url)return;
      navigator.clipboard.writeText(url).then(function(){
        copyButton.textContent='Link copied';
        window.setTimeout(function(){copyButton.textContent='Copy Link'},1600);
      }).catch(function(){copyButton.textContent='Copy failed'});
    });
  }

  function setupDesktopGalleryControls(){
    if(window.innerWidth<992)return;
    var gallery=document.querySelector('.product-photo-container.slider-for');
    var wrapper=document.querySelector('.product-img-box .wrapper-images');
    if(!gallery||!wrapper||wrapper.querySelector('.ff-gallery-arrow'))return;
    if(!window.jQuery||!window.jQuery.fn.slick||!gallery.classList.contains('slick-initialized')||gallery.querySelectorAll('.slick-slide:not(.slick-cloned)').length<2){
      var retries=parseInt(gallery.dataset.ffArrowRetries||'0',10);
      if(retries<40){
        gallery.dataset.ffArrowRetries=String(retries+1);
        window.setTimeout(setupDesktopGalleryControls,250);
      }
      return;
    }
    var previous=document.createElement('button');
    var following=document.createElement('button');
    previous.type='button';
    following.type='button';
    previous.className='ff-gallery-arrow ff-gallery-prev';
    following.className='ff-gallery-arrow ff-gallery-next';
    previous.setAttribute('aria-label','Previous product image');
    following.setAttribute('aria-label','Next product image');
    previous.innerHTML='&#8249;';
    following.innerHTML='&#8250;';
    wrapper.appendChild(previous);
    wrapper.appendChild(following);
    previous.addEventListener('click',function(){window.jQuery(gallery).slick('slickPrev')});
    following.addEventListener('click',function(){window.jQuery(gallery).slick('slickNext')});
  }

  function setupDescriptionPreview(){
    var description=document.querySelector('#collapse-tab1');
    if(!description||description.dataset.ffDescriptionReady==='1'||description.textContent.trim().length<500)return;
    description.dataset.ffDescriptionReady='1';
    var body=document.createElement('div');
    body.className='ff-description-preview__body';
    while(description.firstChild)body.appendChild(description.firstChild);
    var button=document.createElement('button');
    button.type='button';
    button.className='ff-description-toggle';
    button.textContent='See more';
    button.setAttribute('aria-expanded','false');
    description.appendChild(body);
    description.appendChild(button);
    button.addEventListener('click',function(){
      var expanded=body.classList.toggle('is-expanded');
      button.textContent=expanded?'See less':'See more';
      button.setAttribute('aria-expanded',String(expanded));
    });
  }

  function setupWishlistFeedback(){
    var wishlist=document.querySelector('.groups-btn>.wishlist');
    if(!wishlist||wishlist.dataset.ffFeedbackReady==='1')return;
    wishlist.dataset.ffFeedbackReady='1';
    var toast=document.querySelector('.ff-wishlist-toast');
    if(!toast){
      toast=document.createElement('div');
      toast.className='ff-wishlist-toast';
      toast.setAttribute('role','status');
      toast.setAttribute('aria-live','polite');
      document.body.appendChild(toast);
    }
    var toastTimer=null;
    function isAdded(){
      return wishlist.classList.contains('whislist-added')||wishlist.classList.contains('wishlist-added')||wishlist.classList.contains('is-active');
    }
    function sync(){
      var added=isAdded();
      wishlist.setAttribute('aria-pressed',String(added));
      wishlist.setAttribute('title',added?'Remove from wishlist':'Add to wishlist');
      var sticky=document.querySelector('.ff-sticky-purchase__wishlist');
      if(sticky)sticky.classList.toggle('is-active',added);
    }
    function showFeedback(){
      var added=isAdded();
      toast.textContent=added?'♥ Saved to wishlist':'Removed from wishlist';
      toast.classList.add('is-visible');
      window.clearTimeout(toastTimer);
      toastTimer=window.setTimeout(function(){toast.classList.remove('is-visible')},1800);
      sync();
    }
    wishlist.addEventListener('click',function(){window.setTimeout(showFeedback,250)});
    new MutationObserver(sync).observe(wishlist,{attributes:true,attributeFilter:['class']});
    sync();
  }

  function setupStickyPurchase(){
    var productTop=document.querySelector('.product_top');
    var productShop=productTop&&productTop.querySelector('.product-shop');
    var originalAdd=productShop&&productShop.querySelector('#product-add-to-cart');
    var originalWishlist=productShop&&productShop.querySelector('.groups-btn>.wishlist');
    if(!productTop||!productShop||!originalAdd||productTop.querySelector('.ff-sticky-purchase'))return;

    var bar=document.createElement('div');
    bar.className='ff-sticky-purchase';
    bar.setAttribute('aria-hidden','true');
    bar.innerHTML='<button type="button" class="ff-sticky-purchase__wishlist" aria-label="Add to wishlist"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1.1-1.1a5.5 5.5 0 0 0-7.8 7.8l1.1 1.1L12 21l7.8-7.5 1.1-1.1a5.5 5.5 0 0 0-.1-7.8Z"/></svg></button><button type="button" class="ff-sticky-purchase__add"></button>';
    productTop.appendChild(bar);

    var stickyAdd=bar.querySelector('.ff-sticky-purchase__add');
    var stickyWishlist=bar.querySelector('.ff-sticky-purchase__wishlist');
    if(!originalWishlist)stickyWishlist.hidden=true;

    function sync(){
      stickyAdd.textContent=originalAdd.value||originalAdd.textContent||'Add to cart';
      stickyAdd.disabled=originalAdd.disabled;
      if(originalWishlist){
        var active=originalWishlist.classList.contains('wishlist-added')||originalWishlist.classList.contains('whislist-added')||originalWishlist.classList.contains('is-active')||originalWishlist.getAttribute('aria-pressed')==='true';
        stickyWishlist.classList.toggle('is-active',active);
      }
    }
    stickyAdd.addEventListener('click',function(){originalAdd.click()});
    stickyWishlist.addEventListener('click',function(){if(originalWishlist)originalWishlist.click()});
    new MutationObserver(sync).observe(originalAdd,{attributes:true,attributeFilter:['disabled','value']});
    if(originalWishlist)new MutationObserver(sync).observe(originalWishlist,{attributes:true,attributeFilter:['class','aria-pressed']});

    var ticking=false;
    function position(){
      ticking=false;
      var originalRect=originalAdd.closest('.groups-btn').getBoundingClientRect();
      var topRect=productTop.getBoundingClientRect();
      var shopRect=productShop.getBoundingClientRect();
      var mobile=window.innerWidth<992;
      var originalVisible=originalRect.top>=0&&originalRect.bottom<=window.innerHeight;
      var productVisible=topRect.top<window.innerHeight&&topRect.bottom>0;
      var shouldShow=mobile&&productVisible&&!originalVisible;
      bar.classList.toggle('is-visible',shouldShow);
      document.body.classList.toggle('ff-sticky-cta-visible',shouldShow&&mobile);
      bar.setAttribute('aria-hidden',shouldShow?'false':'true');
      if(!shouldShow)return;

      var contained=!mobile&&topRect.bottom<=window.innerHeight;
      bar.classList.toggle('is-contained',contained);
      if(window.innerWidth>=992){
        bar.style.width=Math.round(shopRect.width)+'px';
        bar.style.left=Math.round(contained?shopRect.left-topRect.left:shopRect.left)+'px';
        bar.style.bottom=contained?'0':'0px';
      }else{
        bar.style.width='';
        bar.style.left='';
        bar.style.bottom='';
      }
      sync();
    }
    function requestPosition(){
      if(ticking)return;
      ticking=true;
      window.requestAnimationFrame(position);
    }
    window.addEventListener('scroll',requestPosition,{passive:true});
    window.addEventListener('resize',requestPosition,{passive:true});
    sync();
    position();
  }

  function setupGalleryConsistency(){
    if(window.innerWidth<992)return;
    var gallery=document.querySelector('.product-photo-container.slider-for'),nav=document.querySelector('.product-img-box>.slider-nav'),wrapper=document.querySelector('.product-img-box .wrapper-images'),box=document.querySelector('.product-img-box');
    if(!gallery||!wrapper||!box)return;
    function syncHeight(){var height=Math.round(wrapper.getBoundingClientRect().height);if(height>100)box.style.setProperty('--ff-gallery-main-height',height+'px')}
    syncHeight();
    if(window.ResizeObserver&&!box.ffGalleryResizeObserver){box.ffGalleryResizeObserver=new ResizeObserver(syncHeight);box.ffGalleryResizeObserver.observe(wrapper)}
    if(gallery.dataset.ffInitialOrderReady==='1')return;
    if(!window.jQuery||!window.jQuery.fn.slick||!gallery.classList.contains('slick-initialized')){var retries=parseInt(gallery.dataset.ffOrderRetries||'0',10);if(retries<40){gallery.dataset.ffOrderRetries=String(retries+1);window.setTimeout(setupGalleryConsistency,250)}return}
    gallery.dataset.ffInitialOrderReady='1';window.jQuery(gallery).slick('slickGoTo',0,true);if(nav&&nav.classList.contains('slick-initialized'))window.jQuery(nav).slick('slickGoTo',0,true);window.requestAnimationFrame(syncHeight);
  }

  function setupStitchingPricing(){
    var form=document.querySelector('#add-to-cart-form');
    var options=document.querySelector('#infiniteoptions-container');
    if(!form||!options||options.dataset.ffPricingReady==='1')return;
    options.dataset.ffPricingReady='1';
    var state={touched:false,selected:false,priceCents:0};
    window.FFStitchingState=state;

    function parsePrice(text){
      var clean=String(text||'').replace(/\u00a0/g,' ');
      var match=clean.match(/\+\s*(?:PKR|Rs\.?\s*)?([0-9][0-9,]*(?:\.\d{1,2})?)/i)||
        clean.match(/(?:PKR|Rs\.?)\s*([0-9][0-9,]*(?:\.\d{1,2})?)/i);
      if(!match)return 0;
      var value=parseFloat(match[1].replace(/,/g,''));
      return Number.isFinite(value)?Math.round(value*100):0;
    }

    function nearestOptionText(target){
      var node=target;
      for(var depth=0;node&&node!==options&&depth<5;depth++,node=node.parentElement){
        var text=(node.textContent||'').trim();
        if(text.length>0&&text.length<180&&parsePrice(text)>0)return text;
      }
      return '';
    }

    function selectedCopies(){
      var primary=[];
      var hidden=[];
      options.querySelectorAll('select,input').forEach(function(control){
        var type=(control.type||'').toLowerCase();
        if(control.tagName==='SELECT'){
          var selected=control.options[control.selectedIndex];
          if(selected&&control.value)primary.push([control.name,control.value,selected.textContent].join(' '));
          return;
        }
        if(type==='checkbox'||type==='radio'){
          if(!control.checked)return;
          var label=control.id?document.querySelector('label[for="'+CSS.escape(control.id)+'"]'):null;
          primary.push([control.name,control.value,label?label.textContent:'',control.closest('label')?control.closest('label').textContent:''].join(' '));
          return;
        }
        if(type==='hidden'&&/stitch|sew|embellish|pkr|rs\.?/i.test([control.name,control.value].join(' '))){
          hidden.push([control.name,control.value].join(' '));
        }
      });
      return primary.length?primary:hidden;
    }

    function sync(fallbackText){
      if(!state.touched){
        state.selected=false;
        state.priceCents=0;
      }else{
        var copies=selectedCopies();
        var hasPricedControl=copies.some(function(copy){return parsePrice(copy)>0});
        if(fallbackText&&!hasPricedControl)copies.push(fallbackText);
        var seen={};
        var total=0;
        copies.forEach(function(copy){
          if(/unstitched|no stitching|without stitching|none/i.test(copy))return;
          var price=parsePrice(copy);
          if(price<=0)return;
          var key=String(copy).replace(/\s+/g,' ').trim().toLowerCase();
          if(seen[key])return;
          seen[key]=true;
          total+=price;
        });
        state.selected=total>0;
        state.priceCents=total;
      }
      document.dispatchEvent(new CustomEvent('ff:stitching-change',{detail:{selected:state.selected,priceCents:state.priceCents}}));
    }

    function handleUserEvent(event){
      if(!event.isTrusted)return;
      state.touched=true;
      var fallback=nearestOptionText(event.target);
      window.setTimeout(function(){sync(fallback)},40);
    }

    options.addEventListener('click',handleUserEvent,true);
    options.addEventListener('change',handleUserEvent,true);
    options.addEventListener('input',handleUserEvent,true);
    new MutationObserver(function(){sync('')}).observe(options,{childList:true,subtree:true,attributes:true,attributeFilter:['checked','selected','class','aria-pressed']});
    sync('');
  }

  function setupDeliveryInfo(){
    var row=document.querySelector('[data-ff-delivery-open]');
    var dialog=document.querySelector('.ff-delivery-dialog');
    if(!row||!dialog||dialog.dataset.ffReady==='1')return;
    dialog.dataset.ffReady='1';
    var close=dialog.querySelector('[data-ff-delivery-close]');

    function openDialog(){if(typeof dialog.showModal==='function')dialog.showModal();else dialog.setAttribute('open','')}
    function closeDialog(){if(typeof dialog.close==='function')dialog.close();else dialog.removeAttribute('open')}

    row.addEventListener('click',openDialog);
    if(close)close.addEventListener('click',closeDialog);
    dialog.addEventListener('click',function(event){if(event.target===dialog)closeDialog()});
  }

  function setupYeyloInstallments(){
    var block=document.querySelector('[data-ff-yeylo]');
    if(!block||block.dataset.ffReady==='1')return;
    block.dataset.ffReady='1';
    var amount=block.querySelector('[data-ff-yeylo-amount]');
    var basePrice=parseInt(block.getAttribute('data-base-price-cents')||'0',10);

    function formatRupees(value){
      return 'Rs. '+Math.ceil(value).toLocaleString('en-PK');
    }
    function readDisplayedBase(){
      var salePrice=document.querySelector('.product-shop .prices .on-sale, .product-shop .prices .price');
      if(!salePrice)return basePrice;
      var match=(salePrice.textContent||'').replace(/,/g,'').match(/([0-9]+(?:\.\d+)?)/);
      return match?Math.round(parseFloat(match[1])*100):basePrice;
    }
    function render(refreshBase){
      if(refreshBase)basePrice=readDisplayedBase();
      amount.textContent=formatRupees((basePrice*1.15/3)/100);
    }

    var form=document.querySelector('#add-to-cart-form');
    if(form)form.addEventListener('change',function(event){
      if(event.target.closest('#infiniteoptions-container'))return;
      window.setTimeout(function(){render(true)},120);
    });
    render(false);
  }

  function initializeApprovedPdp(){
    setupMobileGallery();
    setupDesktopGalleryControls();
    setupGalleryConsistency();
    setupStitchingPanel();
    setupStitchingPricing();
    setupDeliveryInfo();
    setupYeyloInstallments();
    setupShareDialog();
    setupDescriptionPreview();
    setupStickyPurchase();
    setupWishlistFeedback();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initializeApprovedPdp,{once:true});
  else initializeApprovedPdp();
  document.addEventListener('shopify:section:load',initializeApprovedPdp);
})();

/* Offer Library: apply a public voucher without disturbing product/cart add flows. */
(function(){
  var activeOfferTrigger=null;
  function getOfferDialog(trigger){
    var id=trigger&&trigger.getAttribute('aria-controls');
    return id?document.getElementById(id):document.getElementById('ff-product-offers-dialog');
  }
  function openOfferDialog(trigger){
    var dialog=getOfferDialog(trigger);
    if(!dialog)return;
    activeOfferTrigger=trigger;
    if(typeof dialog.showModal==='function')dialog.showModal();
    else dialog.setAttribute('open','');
  }
  function closeOfferDialog(dialog){
    if(!dialog)return;
    if(typeof dialog.close==='function')dialog.close();
    else dialog.removeAttribute('open');
    if(activeOfferTrigger&&typeof activeOfferTrigger.focus==='function')activeOfferTrigger.focus();
    activeOfferTrigger=null;
  }
  function setButtonState(button,label,disabled){
    button.textContent=label;
    button.disabled=Boolean(disabled);
  }
  async function applyOffer(button){
    var code=button.getAttribute('data-discount-code');
    if(!code||button.disabled)return;
    setButtonState(button,'Applying…',true);
    try{
      var root=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
      var response=await fetch(root+'cart/update.js',{
        method:'POST',
        credentials:'same-origin',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({discount:code})
      });
      if(!response.ok)throw new Error('Discount request failed');
      var cart=await response.json();
      var discounts=Array.isArray(cart.discount_codes)?cart.discount_codes:[];
      var applied=discounts.some(function(discount){
        return String(discount.code||'').toLowerCase()===code.toLowerCase()&&discount.applicable!==false;
      });
      setButtonState(button,applied?'Applied':'Saved',true);
      button.setAttribute('aria-label',applied?'Offer applied':'Offer saved and will apply when eligible');
      document.dispatchEvent(new CustomEvent('ff:discount-applied',{detail:{code:code,cart:cart}}));
    }catch(error){
      setButtonState(button,'Try again',false);
    }
  }
  document.addEventListener('click',function(event){
    var chip=event.target.closest('.ff-offer-chip,.ff-offer-more');
    if(chip){
      event.preventDefault();
      openOfferDialog(document.getElementById('ff-product-offers'));
      return;
    }
    var opener=event.target.closest('.ff-product-offers[data-ff-offers-open]');
    if(opener){openOfferDialog(opener);return}
    var closer=event.target.closest('.ff-offers-dialog--product [data-ff-offers-close]');
    if(closer){closeOfferDialog(closer.closest('dialog'));return}
    var dialog=event.target.closest('.ff-offers-dialog--product');
    if(dialog&&event.target===dialog){closeOfferDialog(dialog);return}
    var button=event.target.closest('.ff-offers-dialog--product [data-ff-apply-offer]');
    if(button)applyOffer(button);
  });
})();

/* Lightweight product image zoom: avoids the theme zoom layer resizing after load. */
(function(){
  function initFFProductZoom(){
    var wrapper=document.querySelector('.product-img-box .wrapper-images');
    if(!wrapper||wrapper.dataset.ffZoomReady==='1')return;
    wrapper.dataset.ffZoomReady='1';
    var activeImage=null;
    function reset(){
      if(activeImage){
        activeImage.style.transform='';
        activeImage.style.transformOrigin='';
        var activeAnchor=activeImage.closest('a[data-zoom]');
        if(activeAnchor)activeAnchor.classList.remove('ff-zoom-active');
      }
      activeImage=null;
    }
    wrapper.addEventListener('pointermove',function(event){
      if(!window.matchMedia('(hover:hover) and (pointer:fine)').matches)return;
      var anchor=event.target.closest('a[data-zoom]');
      if(!anchor||!wrapper.contains(anchor))return;
      var image=anchor.querySelector('img:not(.zoomImg)');
      if(!image)return;
      if(activeImage&&activeImage!==image)reset();
      var rect=anchor.getBoundingClientRect();
      var x=Math.max(0,Math.min(100,(event.clientX-rect.left)/rect.width*100));
      var y=Math.max(0,Math.min(100,(event.clientY-rect.top)/rect.height*100));
      image.style.transformOrigin=x+'% '+y+'%';
      image.style.transform='scale(1.65)';
      anchor.classList.add('ff-zoom-active');
      activeImage=image;
    });
    wrapper.addEventListener('pointerleave',reset);
    wrapper.addEventListener('click',reset);
  }
  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',initFFProductZoom,{once:true});
  }else{
    initFFProductZoom();
  }
})();
